var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPrimaryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.888,
    height: 29.917,
    viewBox: "0 0 29.888 29.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3229",
    "data-name": "Group 3229",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M107.6,92.047a2.081,2.081,0,0,1-2.105,2.075H88.832a2.082,2.082,0,0,1-2.105-2.075V75.326a2.1,2.1,0,0,1,2.105-2.075h8.515l2.694-2.694H88.832A4.8,4.8,0,0,0,84,75.326V92.047a4.81,4.81,0,0,0,4.83,4.8h16.69a4.81,4.81,0,0,0,4.83-4.8V80.807L107.659,83.5v8.546Z",
    transform: "translate(-84.002 -67.43)",
    fill: "#9149ff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M235.482,18.4,231.7,14.65a2.188,2.188,0,0,0-1.517-.65,2.1,2.1,0,0,0-1.517.619L214.736,28.553a2.141,2.141,0,0,0-.619,1.393l-.248,3.994a2.213,2.213,0,0,0,.619,1.672,2.157,2.157,0,0,0,1.517.619h.124l4.025-.247a2.142,2.142,0,0,0,1.393-.619l13.9-13.9a2.157,2.157,0,0,0,.619-1.517,2.03,2.03,0,0,0-.588-1.548ZM226.6,20.534l3,3-6.967,6.936-3-3Zm-6.812,12.788-3.189.186.186-3.189.9-.9,3,3Zm11.7-11.736-2.973-2.973,1.672-1.672,3,3Z",
    transform: "translate(-206.685 -14)",
    fill: "#9149ff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPrimaryIcon);
export default __webpack_public_path__ + "static/media/EditPrimaryIcon.da9d2daa0d8855a294350f31f91d4643.svg";
export { ForwardRef as ReactComponent };